import { getToken } from '../_helpers/commonFunctions';

import apiRequest from './apiRequest';
import apiEndpoints from './apiEndpoints';

export const sendChatbotMessage = (message, sessionId) => {
  return apiRequest({
    method: 'post',
    endpoint: apiEndpoints.chatbot,
    authKey: getToken(),
    payload: { 
      message,
      sessionId,
      currentPath: globalThis.location.pathname,
    },
  });
};
